import { render, staticRenderFns } from "./aside-panel-recent-activities.vue?vue&type=template&id=71121310&scoped=true"
import script from "./aside-panel-recent-activities.vue?vue&type=script&lang=js"
export * from "./aside-panel-recent-activities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71121310",
  null
  
)

export default component.exports